var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarquee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    id: "marquee",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28 8c0 2.21-1.79 4-4 4h-8c-2.21 0-4 1.79-4 4v8c0 2.21-1.79 4-4 4s-4-1.79-4-4v-8C4 9.37 9.37 4 16 4h8c2.21 0 4 1.79 4 4zM12 40v16c0 2.21-1.79 4-4 4s-4-1.79-4-4V40c0-2.21 1.79-4 4-4s4 1.79 4 4zm16 48c0 2.21-1.79 4-4 4h-8C9.37 92 4 86.63 4 80v-8c0-2.21 1.79-4 4-4s4 1.79 4 4v8c0 2.21 1.79 4 4 4h8c2.21 0 4 1.79 4 4zm32 0c0 2.21-1.79 4-4 4H40c-2.21 0-4-1.79-4-4s1.79-4 4-4h16c2.21 0 4 1.79 4 4zm32-16v8c0 6.63-5.37 12-12 12h-8c-2.21 0-4-1.79-4-4s1.79-4 4-4h8c2.21 0 4-1.79 4-4v-8c0-2.21 1.79-4 4-4s4 1.79 4 4zm0-32v16c0 2.21-1.79 4-4 4s-4-1.79-4-4V40c0-2.21 1.79-4 4-4s4 1.79 4 4zm0-24v8c0 2.21-1.79 4-4 4s-4-1.79-4-4v-8c0-2.21-1.79-4-4-4h-8c-2.21 0-4-1.79-4-4s1.79-4 4-4h8c6.63 0 12 5.37 12 12zM60 8c0 2.21-1.79 4-4 4H40c-2.21 0-4-1.79-4-4s1.79-4 4-4h16c2.21 0 4 1.79 4 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarquee);
export default __webpack_public_path__ + "static/media/marquee.88267c162dc925a05764b611c1b2d8ff.svg";
export { ForwardRef as ReactComponent };